/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Ship_From_CountryInputs */

const en_reference_field_ship_from_country = /** @type {(inputs: Reference_Field_Ship_From_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ship-from country`)
};

/**
* | output |
* | --- |
* | "Ship-from country" |
*
* @param {Reference_Field_Ship_From_CountryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_ship_from_country = /** @type {((inputs?: Reference_Field_Ship_From_CountryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Ship_From_CountryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_ship_from_country(inputs)
});